import { Component, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';

@Component({
	selector: 'app-up-down',
	templateUrl: './up-down.component.html',
	styleUrls: ['./up-down.component.scss' ]
})
export class UpDownComponent {

	@Input() Valor: number = 1;
	@Output() ValorChange: EventEmitter<number> = new EventEmitter();
	@Input() ClaseCSS: string = "";
	@Input() Descripcion: string = "";
	@ViewChild("txtValor") txtValor: ElementRef;

	constructor() { }

	public CambiarValor(valor: number): void {
		let ValorTmp = this.Valor + Number(valor);

		if (ValorTmp < 0) {
			this.Valor = 0;
		}
		else {
			this.Valor = ValorTmp;
		}

		this.ValorChange.emit(this.Valor);
	}

	public onInputChange(nuevoValor: number): void {
		nuevoValor = Number(nuevoValor);

		if (nuevoValor) {
			if (nuevoValor < 0) {
				this.Valor = 0;
			}
			else {
				this.Valor = nuevoValor;
			}
		}
		else {
			this.Valor = 0;
		}

		this.txtValor.nativeElement.value = this.Valor;
		this.ValorChange.emit(this.Valor);
	}
}